import { Checkbox, Typography } from "@mui/material";

type Props = {
  show: boolean;
  onFilterChange: (show: boolean) => void;
  label: string;
};

const CheckboxFilter = ({ show, onFilterChange, label }: Props) => {
  return (
    <>
      <Checkbox
        sx={{ color: "#00000085" }}
        checked={show}
        onChange={() => onFilterChange(!show)}
      />
      <Typography variant="secondary">{label}</Typography>
    </>
  );
};

export default CheckboxFilter;
